var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container full py-5 border-top"},[_c('div',{staticClass:"notFound text-center"},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("Sistemde böyle bir kullanıcı bulunamadı!")])])])
}]

export { render, staticRenderFns }